import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { InputCompound } from '@usepepper/sprout-kit-ui';
import { PricingFilterUnit } from '@sales-portal/domain/pricing/blocs/utils/pricing-filter-types';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface Props {
  accessibilityLabel: string;
  affix: string;
  label: string;
  onBlur: () => void;
  onChangeText: (text: string) => void;
  placeholder: string;
  unit: PricingFilterUnit;
  value: string;
}

export const PricingFilterRangeBoundInput: React.FC<Props> = ({
  accessibilityLabel,
  affix,
  label,
  onBlur,
  onChangeText,
  placeholder,
  unit,
  value,
}) => {
  const [styles, theme] = useStyles();

  // A currency symbol leads the number ("$ 2.20"); every other unit trails it.
  const isLeading = unit === PricingFilterUnit.Currency;

  const affixNode = affix ? (
    <View style={isLeading ? styles.leadingAffix : styles.trailingAffix}>
      <Typography color={theme.sk.color.text.tertiary} variant="paragraph-md">
        {affix}
      </Typography>
    </View>
  ) : null;

  return (
    <InputCompound size="$44">
      <InputCompound.Label>{label}</InputCompound.Label>
      <InputCompound.Box>
        {isLeading ? affixNode : null}
        <InputCompound.Section>
          <InputCompound.Area
            accessibilityLabel={accessibilityLabel}
            inputMode="decimal"
            onBlur={onBlur}
            onChangeText={onChangeText}
            placeholder={placeholder}
            value={value}
          />
        </InputCompound.Section>
        {isLeading ? null : affixNode}
      </InputCompound.Box>
    </InputCompound>
  );
};

const useStyles = createStyles((theme) => ({
  leadingAffix: {
    justifyContent: 'center',
    paddingLeft: theme.sk.spacing.spaceSMedium,
  },
  trailingAffix: {
    justifyContent: 'center',
    paddingRight: theme.sk.spacing.spaceSMedium,
  },
}));
